// extracted by mini-css-extract-plugin
export var block = "footer-module--block--2FFzZ";
export var button = "footer-module--button--6iupX";
export var child = "footer-module--child--bADWp";
export var container = "footer-module--container--2xk9s";
export var joinNow = "footer-module--joinNow--3AsWV";
export var links = "footer-module--links--2jY4R";